import { useEffect } from 'react'
export const originalTitle = document.title || 'Wanda Web App'

export const useDocumentTitle = (title?: string) => {
  useEffect(() => {
    document.title = title ? `${title} – ${originalTitle}` : originalTitle
  }, [title])
}
